// extracted by mini-css-extract-plugin
export default {"loginForm":"Login_loginForm__XGdW5","error":"Login_error__ByltQ"};